if (typeof JW === 'undefined') JW = {};
JW.Modal = (function ($)
{
    var _pri = {};
    var publ = {};

    _pri.cname = 'MODAL';
    _pri.opts = {
        dbg_lvl: 1,
        a_in: 'bounceInDown',       // animation in (bounceInDown, zoomInDown, zoomInUp ...)
        a_out: 'adur05 flipOutX',   // animation out
        urls: {
            login: '/login',        // user login
            rate: '/rate',          // user rating companies
            ratings: '/ratings',    // ratings companies
            bpr: '/bpr',            // branch prices
            tpl: '/tpl',            // parts reload
            srf: '/srf',            // session refresh
            prices: '/preise',      // prices table
            variants: '/varianten'  // prices table
        }
    };

    _pri.$win            = null;
    _pri.$doc            = null;
    _pri.$body           = null;
    _pri.$nav_top        = null;
    _pri.$nav_top_main   = null;
    _pri.$nav_top_sub    = null;
    _pri.$nav_top_open   = null;
    _pri.$mask           = $('<div class="mdl-mask"></div>');
    _pri.$lind           = $('<div class="spinner"><div class="rect1"></div><div class="rect2"></div><div class="rect3"></div><div class="rect4"></div><div class="rect5"></div></div>').appendTo(_pri.$mask);
    _pri.$bd             = $('<div id="mbd" class="mbd fade show"></div>'); // nav top back drop
    _pri.win_msg         = '\
    <div class="mdl drk mdl-msg rounded">\
        <div class="mdl-header">\
            <button type="button" class="btn btn-primary mdl-close"><i class="fa fa-times" aria-hidden="true"></i></button>\
            <h1 class="h2">Hinweis</h1>\
        </div>\
        <div class="mdl-body"></div>\
        <div class="mdl-footer">\
            <a class="btn btn-primary-l mdl-msg-ok rounded-top-0 rpl" href="#">OK</a>\
        </div>\
    </div>';
    _pri.$mwin           = null;

    _pri.inited          = false;
    _pri.page            = null;
    _pri.masked          = false;
    _pri.scroll_top_buff = 0;
    _pri.is_loading      = false;
    _pri.is_mask_hiding  = false;
    _pri.show_mask_again = false;
    _pri.mask_forced     = false;
    _pri.curwin = '';
    _pri.wins = ['/login', '/logout', '/rate', '/ratings', '/preise', '/varianten', '/bpr', '/cple'];

    _pri.srf_tio = 1000 * 60 * 10;      // session refresh interval

    _pri.extend = function()
    {
        JW.ExtCommon(jQuery, publ, _pri);
    };

    publ.init = function()
    {
        _pri.dbgG('*** init()', _pri.cname);

        if (_pri.inited)
        {
            return;
        }
        _pri.inited = true;

        _pri.$win          = $(window);
        _pri.$doc          = $(document);
        _pri.$body         = $('body');
        _pri.$nav_top      = $('#nav-top');
        _pri.$nav_top_main = $('#nav-top-main');
        _pri.$nav_top_sub  = $('#nav-top-sub');
        _pri.page = JW.Page;

        _pri.is_firefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;

        _pri.$doc.on('click', '.mdl-mask', _pri.maskClicked);
        // _pri.$doc.on('click', '.mdl-header > button', _pri.closeAll);
        _pri.$doc.on('click', '.mdl .mdl-close', _pri.closeAll);
        _pri.$doc.on('click', '.mdl .mdl-close-frc', function(e) {
            _pri.mask_forced = false;
            _pri.closeAll(e);
        });
        if (!_pri.is_firefox)
        {
            _pri.$doc.on('click', '.mdl-footer > .mdl-msg-ok', _pri.closeAll);
        }
        else
        {
            _pri.$doc.on('mouseup', '.mdl-footer > .mdl-msg-ok', _pri.closeAll);
        }
        _pri.$doc.on('submit', '.mdl .mdl-form', _pri.submitForm);

        _pri.$doc.on('click', '#mbtn', _pri.mbtnClick);
        _pri.$doc.on('click', '.mbd', _pri.mbdClick);
        _pri.$doc.on('click', '.nav-sub-dis', _pri.mbdClick);
        _pri.$doc.on('click keyenter keyspace', '.jssetc', _pri.onJsSetE);
        _pri.$doc.on('change', '.jssets', _pri.onJsSetE);
        _pri.$doc.on('submit', 'form.smsm', _pri.onSmsm); //submit set mask
        _pri.$doc.on('click', '.emsg', _pri.emsgClick);
        _pri.$doc.on('click', '.pstd', _pri.pstLnk);

        // _pri.$doc.on('click', '#btn-cbd-info', function(e) {
        //     _pri.dbg('*** cbd-info.click()');
        //
        //     var $info = $('#nav-top-cbd-info');
        //     if ($info.length > 0)
        //     {
        //         _pri.dbg('    info sub found');
        //         if ($info.hasClass('show'))
        //         {
        //             _pri.setTopNavSub(false);
        //         }
        //         else
        //         {
        //             _pri.setTopNavSub(true, $info);
        //         }
        //     }
        // });

        _pri.$doc.on('close', '#messeinfo_gll', _pri.closeAll);

        _pri.$doc.on('keydown', function(e)
        {
            if (_pri.masked && e.keyCode === 9)
            {
                var $mdl = $('.mdl[role="dialog"]');
                if ($mdl.length == 1)
                {
                    _pri.dbgB('*** tab in mdl dialog ...');

                    var $felms = $mdl.find('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]');

                    if ($felms.length > 0)
                    {
                        var $first = $felms.first();
                        var $last  = $felms.last();
                        var aelm   = document.activeElement;

                        if ($first.is(e.target) && e.shiftKey)
                        {
                            _pri.dbgR('    now first');
                            e.stopImmediatePropagation();
                            e.stopPropagation();
                            e.preventDefault();
                            $last.focus();
                        }
                        else if ($last.is(e.target) && !e.shiftKey)
                        {
                            _pri.dbgR('    now last');
                            e.stopImmediatePropagation();
                            e.stopPropagation();
                            e.preventDefault();
                            $first.focus();
                        }
                        else if ($mdl.has(e.target).length === 0)
                        {
                            _pri.dbgR('    outside!');
                            e.stopImmediatePropagation();
                            e.stopPropagation();
                            e.preventDefault();
                            $first.focus();
                        }

                        // if ($mdl.has(e.target).length > 0)
                        // {
                        //     _pri.dbgY('    YUP');
                        //     _pri.dbgY('    target:', e.target);
                        //     _pri.dbgY('    aelm:', aelm);
                        // }
                        // else
                        // {
                        //     _pri.dbgY('    NOPE');
                        //     _pri.dbgY('    target:', e.target);
                        //     _pri.dbgY('    aelm:', aelm);
                        //     _pri.dbgY('    first:', $first);
                        //     e.stopImmediatePropagation();
                        //     e.stopPropagation();
                        //     e.preventDefault();
                        //     $first.focus();
                        // }
                    }
                }
            }
        });

        $(document).on('mouseup', '.ddaxj', function(e)
        {
            e.stopImmediatePropagation();
            e.stopPropagation();
            e.preventDefault();
            // _pri.dbgY('NOW!!!!!!!!!!!!!!!!!');

            // _pri.dbg('    this:', this);
            var $ddt = $(this);
            var show  = $ddt.parent().hasClass('show');
            // _pri.dbgY('    show: ', show);
            var href  = $ddt.data('href');

            if (typeof href !== 'undefined' && $ddt.length > 0)
            {
                // _pri.dbgY('    2222');
                if (!show)
                {
                    _pri.setTopNavSub(false);

                    publ.cll({_url: href, _msk: false, _dtp: 'JSON'}, function(xhr) {
                        var ret = JSON.parse(xhr.responseText);
                        // _pri.dbg('    ret json: ', ret, 'statusText: ', xhr.statusText);
                        publ.handleJSONRet(ret, xhr.statusText, xhr);
                        $ddt.dropdown('update');
                    });
                }
                // else
                // {
                //     $ddt.parent().find('.dropdown-menu').html('<a class="dropdown-item text-center"><i class="fa fa-refresh fa-spin fa-fw op03"></i></a>');
                // }
            }
        });

        _pri.page.on('modal:top_nav_shown', function(e, o) {
            // _pri.dbg('on modal:top_nav_shown o: ', o);
            $('.topmenus').each(function(ix) {
                var $dd = $(this);
                // _pri.dbg(ix, $dd);
                if ($dd.parent().hasClass('show'))
                {
                    $dd.trigger('click');
                }
            });
        });

        _pri.page.on('page:set_part_done', function(e, o) {
            _pri.dbg('on page:set_part_done o: ', o);

            switch(o.part)
            {
                case 'nav-top':
                    _pri.$nav_top_main = $('#nav-top-main');
                    _pri.$nav_top_sub  = $('#nav-top-sub');
                    _pri.setTopNavSub(false);
                break;
            }
        });

        _pri.page.on('modal:show_nav_sub', function(e, o) {
            _pri.dbg('on modal:show_nav_sub o: ', o);
            if (o.state)
            {
                var $el = $(o.sel);
                if ($el.length > 0)
                {
                    _pri.setTopNavSub(true, $el);
                }
            }
            else
            {
                _pri.setTopNavSub(false);
            }
        });

        _pri.initOpts();
        _pri.initLinks();

        setTimeout(_pri.srf, _pri.srf_tio);
    };

    // mask: 0 - close   | 1 - show | * - keep cur
    // lock: 0 - unlock  | 1 - lock | * - keep cur
    // lind: 0 - hide    | 1 - show | * - keep cur
    publ.setMask = function(mask, lock, lind)
    {
        // _pri.dbg('*** setMask()', mask, lock, lind);

        switch (mask)
        {
            case 0:
                _pri.closeMaskAnim();
            break;
            case 1:
                _pri.showMask();
            break;
            default:

            break;
        }

        switch (lock)
        {
            case 0:
                _pri.is_loading = false;
            break;
            case 1:
                _pri.is_loading = true;
            break;
            default:

            break;
        }

        switch (lind)
        {
            case 1:
                _pri.$lind.removeClass('d-none');
            break;
            case 0:
                _pri.$lind.addClass('d-none');
            break;
            default:

            break;
        }
    };

    publ.hasMask = function()
    {
        return _pri.masked;
    };

    // guess btns_cbs was button callbacks - but was never used ... removed
    // hdl - default: Hinweis
    // cls: classes to add to mdl
    publ.showMsg = function(str, hdl, cls)
    {
        _pri.dbgG('*** showMsg() cls:', cls);

        var $win = $(_pri.win_msg);
        if (typeof hdl !== 'undefined' && '' != hdl)
        {
            $win.find('.mdl-header > h1').html(hdl);
        }
        if (typeof cls !== 'undefined' && '' != cls)
        {
            $win.addClass(cls);
        }
        $win.find('.mdl-body').html(str);
        _pri.showMask();
        _pri.showWin($win, 'msg');
    };

    publ.showMsgWin = function($win, win)
    {
        if (typeof win !== 'string')
        {
            win = 'msg';
        }
        _pri.showMask();
        _pri.showWin($win, win);
    };

    publ.closeWin = function(win)
    {
        _pri.dbgG('*** closeWin() win:', win, 'curwin:', _pri.curwin);
        // if (typeof win === 'undefined')
        // {
        //     win = _pri.curwin;
        // }

        if (win == _pri.curwin)
        {
            _pri.closeWin();
        }
    };

    publ.closeWinAnim = function(win, cb)
    {
        if (win == _pri.curwin)
        {
            _pri.$mwin.one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(e) {
                // _pri.dbg('    on anim END e: ', e);
                publ.closeWin(win);
                if (typeof cb === 'function')
                {
                    cb();
                }
            });
            _pri.$mwin.removeClass(_pri.opts.a_in);
            _pri.$mwin.addClass(_pri.opts.a_out);
        }
    };

    _pri.handleStatus = function(jq_xhr)
    {
        _pri.dbgG('*** handleStatus() status: ', jq_xhr.status, ' statusText: ', jq_xhr.statusText);
        if (jq_xhr.status == 202)
        {
            if (jq_xhr.statusText == '.')
            {
                window.location.reload();
                //window.history.go(0);
            }
            else if (jq_xhr.statusText == '/')
            {
                // 261023 server sends the bare root (session/permission fallbacks), keep it on the site's start page
                window.location.href = _pri.opts.home_url;
            }
            else
            {
                window.location.href = jq_xhr.statusText;
            }
            return true;
        }
        else if (jq_xhr.status == 204)
        {
            if (jq_xhr.statusText == 'LoggedOut')
            {
                _pri.dbg('handleStatus LoggedOut');
                _pri.page.trigger('modal:logged_out', {});
                // _pri.getPart('nav-top');
            }
            else if (jq_xhr.statusText == 'LoggedIn')
            {
                _pri.dbg('handleStatus LoggedIn');
                _pri.page.trigger('modal:logged_in', {});
                _pri.getPart('nav-top');
            }
            else
            {
                _pri.dbg('handleStatus LoggedIn fair');
                _pri.page.trigger('modal:logged_in', {});

                var rx = RegExp('^LoggedIn,([0-9]+),([a-z0-9\/_-]+)$');
                var mtc = jq_xhr.statusText.match(rx);
                _pri.dbg('    mtc:', mtc);
                if (mtc.length == 3)
                {
                    _pri.getPart('nav-top', {fid: mtc[1], flnk: mtc[2]});

                    var cll = {
                        _url:   '/_wgt/footer/fair',
                        _msk:   false,
                        _dtp:   'JSON',
                        _frmdt: {fid: mtc[1], flnk: mtc[2]}
                    };
                    publ.cll(cll);
                }
                else
                {
                    _pri.getPart('nav-top');
                }
            }
            return true;
        }
        else
        {
            //window.location.reload();
        }
        return false;
    };

    _pri.onSmsm = function(e)
    {
        publ.setMask(1, 1, 1);
    };

    _pri.submitForm = function(e)
    {
        e.stopPropagation();
        e.preventDefault();
        _pri.dbgG('*** submitForm() e', e);

        var $frm = $(this); //$(e.currentTarget);
        _pri.dbg($frm);
        //_pri.dbg('attr', $frm.attr('action'));
        //_pri.dbg('prop', $frm.prop('action'));
        var win = $frm.attr('action');
        var form_data = $frm.serializeArray();

        // _pri.dbg('    form_data: ', form_data);
        _pri.dbg('    calling close win anim ...');

        _pri.closeWinAnim(function() {
            publ.get(win, form_data);
        });

        return false;
    };

    publ.closeGet = function(win)
    {
        _pri.closeWinAnim(function() {
            publ.get(win);
        });
    };

    _pri.pstLnk = function(e)
    {
        e.stopPropagation();
        e.preventDefault();
        _pri.dbgG('*** pstLnk()');

        let $this = $(this);
        let href  = $this.attr('href');
        if (typeof href !== 'string' || href == '')
        {
            _pri.dbg('    missing href - will search pstd ...');
        }
        let pstd  = $this.data('pstd');
        if (typeof pstd === 'undefined' || !pstd)
        {
            _pri.dbgR('    !!! missing data-pstd!');
            return;
        }

        _pri.dbg('    pstd:', pstd);

        let frm    = document.createElement("form");

        $.each(pstd, function(k, v) {
            _pri.dbg(k, v);

            let inp = document.createElement("input");
            inp.type = "hidden";
            inp.name = k;
            inp.value = v;
            frm.appendChild(inp);

            if (k == 'href')
            {
                href = v;
            }
            else if (k == 'target')
            {
                frm.target = v;
            }
        });

        if (typeof href !== 'string' || href == '')
        {
            _pri.dbgR('    !!! still missing href!');
            return;
        }

        frm.method = "POST";
        frm.action = href;

        document.body.appendChild(frm);
        frm.submit();
    };

    // arbitrary calls to server determined by data-obj
    publ.cll = function(cll, cbf)
    {
        // _json       if set and true simply call handleJSONRet(cll)
        // _$elm       clicked element jquery object, filled by event handler before
        // _evp        event propagation, used in event handler before
        // _url        url to call
        // _msk        show mask - def true
        // _dtp        data type HTML / JSON - def HTML
        // _tgt        target sel to insert HTML
        // _scrlt      sroll to target sel - if undefined && _tgt _tgt will be used
        // _frmdt      if defined: POST with data otherwise GET without
        // cbf         if given call this function on load and return

        _pri.dbgG('*** cll()');

        if (!_pri.isObj(cll))
        {
            _pri.dbgR('    missing cll obj ... return.');
            return false;
        }

        // sometimes we may need the clicked link ... like a pager's link with page number ...
        if (_pri.isObj(cll._$elm))
        {
            let href  = cll._$elm.attr('href');
            if (typeof href !== 'undefined')
            {
                if (!_pri.isObj(cll._frmdt))
                {
                    cll._frmdt = {};
                }
                cll._frmdt.link_href = href;
            }
        }

        if (typeof cll._json === 'boolean' && cll._json)
        {
            publ.handleJSONRet(cll);
            return;
        }

        if (typeof cll._url === 'undefined')
        {
            _pri.dbg('    no url given ... return.');
            return false;
        }

        if (typeof cll._msk === 'undefined' || cll._msk)
        {
            cll._msk = true;
            // _pri.showMask();
            publ.setMask(1, 1, 1);
        }
        else
        {
            cll._msk = false;
        }

        if (typeof cll._dtp === 'undefined')
        {
            cll._dtp = 'HTML';
        }

        if (typeof cll._frmdt === 'object')
        {
            cll._mth = 'POST';
            var form_data = new FormData();

            $.each(cll._frmdt, function(k, v) {
                if (v != '{CURVAL}')
                {
                    form_data.append(k, v);
                }
                else
                {
                    _pri.dbgY('        curval k: ' + k + ' ...');

                    let val = null;
                    var $elm = $('input[name="' + k + '"]');
                    if ($elm.length < 1)
                    {
                        $elm = $(v);
                    }

                    if ($elm.length > 0)
                    {
                        if ($elm.is(':checkbox') && $elm.is(':checked'))
                        {
                            val = $elm.val();
                        }
                        else if ($elm.is(':radio'))
                        {
                            //XXX untested ...
                            _pri.dbg('        found radio, search for checked ...');
                            $elm = $elm.filter(':checked');
                            if ($elm.length > 0)
                            {
                                val = $elm.val();
                            }
                        }
                        else
                        {
                            _pri.dbg('        found ...');
                            val = $elm.val();
                        }
                    }

                    if (val != null)
                    {
                        _pri.dbgY('        set curval k:', k, ' to val: [' + val + ']');
                        form_data.append(k, val);
                    }
                }
            });
        }
        else
        {
            cll._mth = 'GET';
        }

        _pri.dbg('    cll after all:', cll);

        var xhr = new XMLHttpRequest();
        xhr.withCredentials = false;
        xhr.open(cll._mth, cll._url);
        xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        xhr.addEventListener("load", function(e) {
            _pri.dbg('*** cll() on load e, xhr: ', e, xhr);

            if (!_pri.handleStatus(xhr))
            {
                if (typeof cbf === 'function')
                {
                    cbf(xhr);
                    return;
                }

                if (cll._msk)
                {
                    _pri.closeMaskAnim();
                }

                if (cll._dtp == 'JSON')
                {
                    var ret = JSON.parse(xhr.responseText);
                    _pri.dbg('    ret json: ', ret, 'statusText: ', xhr.statusText);
                    publ.handleJSONRet(ret, xhr.statusText, xhr);
                }
                else
                {
                    var $tgt = [];

                    if (typeof cll._tgt !== 'undefined')
                    {
                        $tgt = $(cll._tgt);
                        if ($tgt.length > 0)
                        {
                            $tgt.empty().html(xhr.responseText);
                        }

                        if (typeof cll._ini === 'object')
                        {
                            $.each(cll._ini, function(k, v) {
                                switch (k)
                                {
                                    case 'pdfs':
                                        _pri.page.initPdfWrps(cll._tgt);
                                    break;
                                    default:

                                    break;
                                }
                            });
                        }

                        if (typeof cll._scrlt === 'undefined')
                        {
                            cll._scrlt = cll._tgt;
                        }
                    }

                    if (typeof cll._scrlt !== 'undefined')
                    {
                        var $st = $(cll._scrlt);
                        if ($st.length > 0)
                        {
                            $('html,body').animate({
                                scrollTop: ($st.offset().top - $('#nav-top').outerHeight(true))
                            }, 350);
                        }
                    }

                    if ($tgt.length > 0)
                    {
                        if ($tgt.hasClass('collapse'))
                        {
                            $tgt.collapse('show');
                        }
                        else
                        {
                            $tgt.find('.collapse').first().collapse('show');
                        }
                    }
                }
            }
        });

        if (cll._mth == 'POST')
        {
            xhr.send(form_data);
        }
        else
        {
            xhr.send();
        }
    };

    publ.handleJSONRet = function(ret, stat_str, jq_xhr)
    {
        _pri.dbgB('*** handleJSONRet()');
        _pri.dbg('    ret:', ret);
        // _pri.dbg('    status:', stat_str);
        // _pri.dbg('    jqXHR:', jq_xhr);

        if (typeof jq_xhr !== 'undefined' && _pri.handleStatus(jq_xhr))
        {
            _pri.dbg('    handleStatus() - return.');
            // _pri.closeMaskAnim();
            return;
        }

        if (typeof ret.ev_stp1 !== 'undefined' && $.isArray(ret.ev_stp1))
        {
            _pri.dbg('    ev_stp1 ...');
            $.each(ret.ev_stp1, function(k, v) {
                _pri.dbg('        ' + v);
                _pri.page.trigger(v, ret);
            });
            return;
        }

        // close all mdl wins ...
        if (typeof ret.cmw !== 'undefined')
        {
            _pri.dbg('    cmw ... cmw:', ret.cmw);
            if (ret.cmw == 1)
            {
                _pri.dbgY('        close all mdl wins ...');
                _pri.closeWinForce();
            }
        }

        if (typeof ret.msk === 'object' && $.isArray(ret.msk))
        {
            _pri.dbg('    msk ...', ret.msk);
            if (ret.msk.length >= 3)
            {
                _pri.dbgB('    setting mask ...');
                if (ret.msk.length == 4)
                {
                    if (ret.msk[3] == 1)
                    {
                        _pri.mask_forced = true;
                    }
                    else if (ret.msk[3] == -1)
                    {
                        _pri.mask_forced = false;
                    }
                }
                publ.setMask(ret.msk[0], ret.msk[1], ret.msk[2]);
            }
        }

        if (typeof ret.dis_msk === 'object' && $.isPlainObject(ret.dis_msk))
        {
            _pri.dbg('    dis_msk ...', ret.dis_msk);
            $.each(ret.dis_msk, function(k, v) {
                _pri.dbg('        ' + k + ' v:', v);
                // $('<div>', {
                //     class: 'dis_msk',
                //     on: {
                //         click: function() {
                //             _pri.dbg('... dis_msk clicked ...');
                //             return false;
                //         }
                //     }
                // }).appendTo(k);
                // // OR
                // $(k).addClass('pevn');
                if (v)
                {
                    $(k).prop('inert', true).addClass('inert');
                }
                else
                {
                    $(k).prop('inert', false).removeClass('inert');
                }
            });
        }

        if (typeof ret.mdl === 'object' && $.isPlainObject(ret.mdl))
        {
            _pri.dbg('    mdl ...', ret.mdl);
            if (typeof ret.mdl.url === 'string')
            {
                if (typeof ret.mdl.data === 'object' && $.isPlainObject(ret.mdl.data))
                {
                    publ.get(ret.mdl.url, ret.mdl.data);
                }
                else
                {
                    publ.get(ret.mdl.url);
                }
            }
            else if (typeof ret.mdl.msg === 'string')
            {
                publ.showMsgWin($(ret.mdl.msg));
            }
        }

        $('.is-invalid').removeClass('is-invalid').removeAttr('aria-invalid');

        if (typeof ret.keep_msgs !== 'boolean' || !ret.keep_msgs)
        {
            _pri.dbg('    no keep_msgs - clear .frm-msgs ...');
            $('.frm-msgs').html('');
        }
        else
        {
            _pri.dbg('    keep_msgs ...');
        }

        if (typeof ret.html !== 'undefined' && $.isPlainObject(ret.html))
        {
            _pri.dbg('    html ...');
            $.each(ret.html, function(k, v) {
                _pri.dbg('        ' + k);
                $(k).html(v);
            });
        }

        if (typeof ret.html_rpl !== 'undefined' && $.isPlainObject(ret.html_rpl))
        {
            _pri.dbgY('    html_rpl ...');
            $.each(ret.html_rpl, function(k, v) {
                _pri.dbg('        ' + k);
                $(k).replaceWith(v);
            });
        }

        if (typeof ret.html_app !== 'undefined' && $.isPlainObject(ret.html_app))
        {
            _pri.dbg('    html_app ...');
            $.each(ret.html_app, function(k, v) {
                _pri.dbg('        ' + k);
                $(k).append(v);
            });
        }

        if (typeof ret.src !== 'undefined' && $.isPlainObject(ret.src))
        {
            _pri.dbg('    src ...');
            $.each(ret.src, function(k, v) {
                _pri.dbg('        ' + k);
                $(k).attr('src', v);
            });
        }

        // fade iframe ...
        if (typeof ret.fdei !== 'undefined' && $.isPlainObject(ret.fdei))
        {
            _pri.dbg('    fdei ...');
            $.each(ret.fdei, function(k, v) {
                _pri.dbg('        ' + k);
                $(k).css('opacity', 0);
                setTimeout(function () {
                    $(k).fadeTo(2000 , 1.0);
                }, v);
            });
        }

        // insert tpl elm to tgt elm
        if (typeof ret.tpl !== 'undefined' && $.isPlainObject(ret.tpl))
        {
            _pri.dbg('    tpl ...');
            _pri.getSetTplBySel(ret.tpl);
        }

        // elements to remove
        if (typeof ret.erem !== 'undefined' && $.isPlainObject(ret.erem))
        {
            _pri.dbg('    erem ...');
            $.each(ret.erem, function(k, v) {
                _pri.dbg('        ' + k);
                $(k).remove();
            });
        }

        if (typeof ret.parts !== 'undefined' && $.isPlainObject(ret.parts))
        {
            _pri.dbg('    parts ...');
            $.each(ret.parts, function(k, v) {
                _pri.dbg('        ' + k);
                JW.Page.setPart(k, v);
            });
        }

        if (typeof ret.invalids !== 'undefined' && $.isArray(ret.invalids) && ret.invalids.length > 0)
        {
            _pri.dbg('    invalids ...');
            $.each(ret.invalids, function(k, v) {
                _pri.dbg('        ' + k, v);

                if (_pri.clsacc != null && v.substr(0, 3) == 'cl_')
                {
                    _pri.clsacc.setInvalid(v);
                }
                else
                {
                    let set_invalid_done = false;

                    if (v.substring(0, 1) == '#' || v.substring(0, 1) == '.')
                    {
                        // _pri.dbg('        is selector ...');
                        var $elm = $(v);
                        if ($elm.length > 0)
                        {
                            // _pri.dbg('            found ...');
                            $elm.addClass('is-invalid').attr('aria-invalid', 'true');
                            set_invalid_done = true;
                        }
                    }

                    if (!set_invalid_done)
                    {
                        var $elm = $('input[name="' + v + '"]');
                        if ($elm.length > 0)
                        {
                            $elm.addClass('is-invalid').attr('aria-invalid', 'true');
                            set_invalid_done = true;
                        }
                    }

                    if (!set_invalid_done)
                    {
                        $elm = $('textarea[name="' + v + '"]');
                        if ($elm.length > 0)
                        {
                            $elm.addClass('is-invalid').attr('aria-invalid', 'true');
                            if ($elm.hasClass('tmc'))
                            {
                                $elm = $elm.siblings('.mce-tinymce');
                                if ($elm.length > 0)
                                {
                                    $elm.addClass('is-invalid').attr('aria-invalid', 'true');
                                }
                            }
                            set_invalid_done = true;
                        }
                    }

                    if (!set_invalid_done)
                    {
                        $elm = $('select[name="' + v + '"]');
                        if ($elm.length > 0)
                        {
                            $elm.siblings('.vinp').addClass('is-invalid').attr('aria-invalid', 'true'); // visual input to take borders etc.
                            set_invalid_done = true;
                        }
                    }
                }


                // if (v.substring(0, 1) == '#')
                // {
                //     var $elm = $(v).find('.vinp');
                //     if ($elm.length > 0)
                //     {
                //
                //     }
                //
                // }
                // else
                // {
                //
                // }
            });
        }

        if (typeof ret.fvals !== 'undefined' && $.isPlainObject(ret.fvals))
        {
            _pri.dbg('    fvals ...');
            $.each(ret.fvals, function(k, v) {
                let vstr = (typeof v === 'string' && v.length > 80) ? v.slice(0, 80 - 1) + '…' : v;

                _pri.dbg('        ' + k + ': [' + vstr + ']');

                var $elm = $('input[name="' + k + '"]');
                if ($elm.length < 1)
                {
                    $elm = $(k); // don't forget # ...!
                }

                if ($elm.length > 0)
                {
                    if ($elm.is(':checkbox'))
                    {
                        _pri.dbg('        found checkbox, evaluate val: [' + vstr + ']');
                        if (v == 0)
                        {
                            $elm.prop('checked', false);
                            // $elm.trigger('change');
                        }
                        else
                        {
                            $elm.prop('checked', true);
                            // $elm.trigger('change');
                        }
                    }
                    else if ($elm.is(':radio'))
                    {
                        _pri.dbg('        found radio, search for val: [' + vstr + ']');
                        $elm.filter('[value="' + v + '"]').prop('checked', true);
                    }
                    else
                    {
                        _pri.dbg('        found, set to val: [' + vstr + ']');
                        $elm.val(v);

                        if ($elm.prop('tagName') == 'SELECT')
                        {
                            _pri.dbg('        is select - trigger change');
                            $elm.trigger('change');
                        }

                        // return true; // ??? why? found 200909 ...
                    }


                }
            });
        }

        if (typeof ret.tmcs !== 'undefined' && $.isPlainObject(ret.tmcs))
        {
            _pri.dbg('    tmcs ...');
            $.each(ret.tmcs, function(k, v) {
                _pri.dbg('        ' + k + ': [' + v + ']');

                try
                {
                    tinymce.get(k).setContent(v);
                }
                catch (e)
                {
                    _pri.dbgR('    tmcs failed!!!');
                }
            });
        }

        if (typeof ret.dta !== 'undefined' && $.isPlainObject(ret.dta))
        {
            _pri.dbg('    dta ...');

            let dta;

            $.each(ret.dta, function(k, v) {
                _pri.dbg('        k:', k, ' v:', v);
                let $elm = $(k);

                if ($elm.length > 0 && $.isPlainObject(v))
                {
                    _pri.dbg('        elm found ...');
                    $.each(v, function(k2, v2) {
                        _pri.dbg('            k2:', k2, 'v2:', v2);
                        if ($.isPlainObject(v2))
                        {
                            dta  = $elm.data(k2);
                            _pri.dbg('        dta as obj:', dta);
                            $.each(v2, function(k3, v3) {
                                _pri.dbg('                k3:', k3, 'v3:', v3);
                                if ($.isPlainObject(v3) && $.isPlainObject(dta[k3]))
                                {
                                    dta[k3] = $.extend(dta[k3], v3);
                                }
                                else
                                {
                                    dta[k3] = v3;
                                }
                            });

                            $elm.data(k2, dta);
                        }
                        else
                        {
                            $elm.data(k2, v2);
                        }
                    });

                    dta  = $elm.data();
                    _pri.dbgY('    after all elm.data:', dta);
                }
            });
        }

        if (typeof ret.fbtns !== 'undefined' && $.isPlainObject(ret.fbtns))
        {
            _pri.dbg('    fbtns ...');
            $.each(ret.fbtns, function(k, v) {
                _pri.dbg('        ' + k);
                // _pri.dbg('        ' + v);
                var $elm = $(k);
                if ($elm.length > 0 && typeof $elm.data('fbtn') !== 'undefined')
                {
                    var fbtn = $elm.data('fbtn');
                    if (v == '3')
                    {
                        fbtn.reset();
                        fbtn.resetPv();
                    }
                    else if (v == '2')
                    {
                        fbtn.resetPv();
                    }
                    else if ($v == '1')
                    {
                        fbtn.reset();
                    }
                    return true;
                }
            });
        }

        if (typeof ret.crem !== 'undefined' && $.isPlainObject(ret.crem))
        {
            _pri.dbg('    crem ...');
            $.each(ret.crem, function(k, v) {
                _pri.dbg('        ' + k);
                _pri.dbg('        ', $(k));
                $(k).removeClass(v);
            });
        }

        if (typeof ret.ttls !== 'undefined' && $.isPlainObject(ret.ttls))
        {
            _pri.dbg('    ttls ...');
            $.each(ret.ttls, function(k, v) {
                _pri.dbg('        ' + k);
                _pri.dbg('        ', $(k));
                $(k).prop('title', v);
            });
        }

        if (typeof ret.cadd !== 'undefined' && $.isPlainObject(ret.cadd))
        {
            _pri.dbg('    cadd ...');
            $.each(ret.cadd, function(k, v) {
                _pri.dbg('        ' + k);
                $(k).addClass(v);
            });
        }

        // enable / disable inputs + selects within a wrapper (same semantics as onJsSet's _inps)
        if (typeof ret.disinps !== 'undefined' && $.isPlainObject(ret.disinps))
        {
            _pri.dbg('    disinps ...');
            $.each(ret.disinps, function(k, v) {
                _pri.dbg('        ' + k, v);
                if (v == 'disable')
                {
                    $(k).find('input').prop('disabled', true);
                    $(k).find('select').prop('disabled', true);
                }
                else if (v == 'enable')
                {
                    $(k).find('input').prop('disabled', false);
                    $(k).find('select').prop('disabled', false);
                }
            });
        }

        if (typeof ret.attr0 !== 'undefined' && $.isPlainObject(ret.attr0))
        {
            _pri.dbg('    attr0 ...');
            $.each(ret.attr0, function(k, v) {
                _pri.dbg('        ' + k);
                $(k).attr(v, false);
            });
        }

        if (typeof ret.attr1 !== 'undefined' && $.isPlainObject(ret.attr1))
        {
            _pri.dbg('    attr1 ...');
            $.each(ret.attr1, function(k, v) {
                _pri.dbg('        ' + k);
                $(k).attr(v, true);
            });
        }

        // live-lnk add / rem
        if (typeof ret.llnk !== 'undefined' && $.isPlainObject(ret.llnk))
        {
            _pri.dbg('    llnk ...');
            $.each(ret.llnk, function(k, v) {
                _pri.dbg('        ' + k);
                let $as = $(k).find('a');
                if ($as.length > 0)
                {
                    if (v)
                    {
                        $as.addClass('live-lnk');
                    }
                    else
                    {
                        $as.removeClass('live-lnk');
                    }
                }
            });
        }

        // if (_pri.$xch.length > 0)
        // {
        //     _pri.$xch.html(ret.html);
        //     var $frms = _pri.$xch.find('form.afrm');
        //     $.each($frms, function(k, v) {
        //         //_pri.dbg(k);
        //         //_pri.dbg(v);
        //         JW.AjxFrm(jQuery, v);
        //     });
        // }

        // $msgs = $('#msgs');
        // if ($msgs.length > 0)
        // {
        //     $('html,body').animate({
        //         scrollTop: $msgs.offset().top - 10
        //     }, 350);
        // }

        if (typeof ret.elmi !== 'undefined' && $.isPlainObject(ret.elmi))
        {
            _pri.dbg('    elmi ...');
            $.each(ret.elmi, function(k, v) {
                _pri.dbg('        ' + k);
                if ($.isArray(v) && v.length > 0)
                {
                    _pri.dbg('        call page.initElm()' + k);
                    _pri.page.initElm(k, v);
                }
            });
        }

        if (typeof ret.mdlpos !== 'undefined' && $.isArray(ret.mdlpos))
        {
            _pri.dbg('    mdlpos ...');
            $.each(ret.mdlpos, function(k, v) {
                _pri.dbg('        k: ' + k, 'v: ' + v);
                let $mwin = $(v);
                _pri.dbg($mwin);
                if ($mwin.length > 0)
                {
                    _pri.posWin($mwin);
                }
            });
        }

        // trigger page.resize() ...
        if (typeof ret.rsz !== 'undefined')
        {
            _pri.dbg('    rsz ...');
            if (typeof ret.rsz === 'string')
            {
                _pri.dbg('        string: ' + ret.rsz);
                let undef;
                _pri.page.resize(undef, undef, ret.rsz);
            }
            else if (ret.rsz)
            {
                _pri.dbg('        boolean true');
                _pri.page.resize();
            }
        }

        // trigger resize after timeout - {v:'cols2', t:500}
        if (typeof ret.rszt !== 'undefined')
        {
            _pri.dbg('    rszt ...');
            if (typeof ret.rszt === 'object' && $.isPlainObject(ret.rszt))
            {
                if (typeof ret.rszt.v === 'string')
                {
                    _pri.dbg('        string: ' + ret.rszt);
                    window.setTimeout(function() {
                        let undef;
                        _pri.page.resize(undef, undef, ret.rszt.v);
                    }, ret.rszt.t);
                }
                else if (ret.rszt.v)
                {
                    _pri.dbg('        boolean true');
                    window.setTimeout(function() {
                        let undef;
                        _pri.page.resize();
                    }, ret.rszt.t);
                }
            }
        }

        if (typeof ret.scrollto !== 'undefined')
        {
            let $st, $sc = [];

            // simple scroll to tgt ... even if visible ... optional offs =
            // px kept free above the target (default 44 ~ nav-top)
            if (typeof ret.scrollto === 'object' && $.isPlainObject(ret.scrollto) && typeof ret.scrollto.tgt === 'string')
            {
                _pri.dbg('    scrollto 1 ...', ret.scrollto);

                $st = $(ret.scrollto.tgt);
                if ($st.length > 0)
                {
                    let st_offs = 44; //$('#nav-top').outerHeight(true))
                    if (typeof ret.scrollto.offs !== 'undefined')
                    {
                        st_offs = parseInt(ret.scrollto.offs);
                    }
                    $('html,body').animate({
                        scrollTop: ($st.offset().top - st_offs)
                    }, 350);
                }
            }
            else
            {
                // scroll into view ... if NOT visible ...

                if (typeof ret.scrollto === 'string')
                {
                    $st = $(ret.scrollto);
                }
                else if ($.isArray(ret.scrollto) && ret.scrollto.length == 2)
                {
                    _pri.dbg('    scrollto array ...');

                    $st = $(ret.scrollto[0]);
                    $sc = $(ret.scrollto[1]);
                }

                if ($st.length > 0)
                {
                    _pri.dbg('    scrollto found ...');
                    let sctoffs = 0;
                    if (typeof ret.scrolltopoffs !== 'undefined')
                    {
                        sctoffs = parseInt(ret.scrolltopoffs);
                        _pri.dbg('        scrolltopoffs:', sctoffs);
                    }

                    if (!_pri.page.scrolledInView($st, true))
                    {
                        _pri.dbg('    not in view ...');
                        if (_pri.page.isIosSafari())
                        {
                            // alert('ios_safari! 500 0');
                            window.setTimeout(function() {
                                document.scrollingElement.scrollTop = (($st.offset().top - sctoffs) - $('#nav-top').outerHeight(true));
                                if ($sc.length > 0)
                                {
                                    _pri.dbg('    scrollto inside container ...');
                                    $sc.animate({scrollTop: $sc.scrollTop() + ($st.offset().top - $sc.offset().top)});
                                }
                            }, 500);
                        }
                        else
                        {
                            _pri.dbg('    not visible -> scroll ...');
                            $('html,body').animate({
                                scrollTop: (($st.offset().top - sctoffs) - $('#nav-top').outerHeight(true))
                            }, 350);

                            if ($sc.length > 0)
                            {
                                _pri.dbg('    scrollto inside container ...');
                                $sc.animate({scrollTop: $sc.scrollTop() + ($st.offset().top - $sc.offset().top)});
                            }
                        }
                    }
                    // else
                    // {
                    //     _pri.dbg('    visible -> do NOT scroll ...');
                    // }
                }
            }
        }

        if (typeof ret.ajx === 'object' && $.isPlainObject(ret.ajx))
        {
            _pri.dbg('    ajx ...', ret.ajx);

            if (typeof ret.ajx.url === 'string' && typeof ret.ajx.data === 'object' && $.isPlainObject(ret.ajx.data))
            {
                if (typeof ret.ajx.data.dataType === 'string' && ret.ajx.data.dataType === 'json')
                {
                    publ.get(ret.ajx.url, ret.ajx.data, publ.handleJSONRet);
                }
            }
        }

        if (typeof ret.mdlc === 'boolean' && ret.mdlc)
        {
            _pri.dbg('    mdlc ...', ret.mdlc);
            _pri.closeWinAnim(function() {
                _pri.closeMaskAnim();
                // _pri.dbg('    ... mdlc: win closed');
            });
        }

        if (typeof ret.push_state === 'boolean' && ret.push_state && typeof ret.page_url === 'string' && typeof ret.page_title === 'string')
        {
            _pri.dbg('    push_state ...', ret.push_state, ret.page_url, ret.page_title);
            _pri.dbg('    cur state:', window.history.state);
            if (!_pri.isObj(window.history.state) || typeof window.history.state.live_url !== 'string' || window.history.state.live_url != ret.page_url)
            {
                _pri.dbgY('    push now ...');
                window.history.pushState({live_url: ret.page_url}, ret.page_title, ret.page_url);
                $('title').html(ret.page_title);
            }
        }

        if (typeof ret.loc === 'string' && ret.loc != '')
        {
            _pri.dbg('    loc ...', ret.loc);
            window.location.href = ret.loc;
        }

        if (typeof ret.owin === 'object' && typeof ret.owin.href === 'string' && ret.owin.href != '')
        {
            _pri.dbg('    owin ...', ret.owin);
            var win = window.open(ret.owin.href);
        }

        // more comprehensive ... but no need for ... for now ...
        // from publ.onJsSet()
        //
        // if (p == 'rld')
        // {
        //     window.location.reload(true);
        // }
        // else if (p == 'rpl')
        // {
        //     window.location.replace(cur[p]);
        // }
        // else if (p == 'url')
        // {
        //     window.location.href = cur[p];
        // }
        // else if(p == 'opn')
        // {
        //     var win = window.open(cur[p]);
        // }
        // else
        // {
        //     _pri.dbg('    !!! _win act: [' + p + '] unknown!');
        // }

        if (_pri.isObj(ret.hist_rpl))
        {
            _pri.dbg('    hist_rpl ...', ret.hist_rpl);

            if (typeof ret.hist_rpl.title === 'string')
            {
                if (typeof ret.hist_rpl.url === 'string')
                {
                    history.replaceState(null, '', ret.hist_rpl.url);
                    $('title').html(ret.hist_rpl.title);
                }
                else
                {
                    // obsolet, 2nd arg is unused ... but for compatibility let's keep that here and watch out ...
                    history.replaceState(null, ret.hist_rpl.title);
                }
            }
            else
            {
                history.replaceState(null, '');
            }
        }

        if (typeof ret.ev_end !== 'undefined' && $.isArray(ret.ev_end) && ret.ev_end.length > 0)
        {
            _pri.dbg('    ev_end ...');

            if (typeof ret.blur === 'boolean' && ret.blur)
            {
                _pri.dbg('    explicit blur before ev_end ...', ret.blur);
                if (typeof document.activeElement === 'object' && typeof document.activeElement.blur === 'function' && document.activeElement != document.body)
                {
                    document.activeElement.blur();
                }
            }

            $.each(ret.ev_end, function(k, v) {
                _pri.dbg('        ' + v);
                if ($.isArray(v) && v.length == 2)
                {
                    $(v[0]).trigger(v[1]);
                }
                else
                {
                    _pri.page.trigger(v, ret);
                }
            });
            return;
        }

        // prevent re-submit on Enter ...
        // _pri.dbgY('call document.activeElement.blur() typeof document.activeElement:', typeof document.activeElement);
        if (typeof document.activeElement === 'object' && typeof document.activeElement.blur === 'function' && document.activeElement != document.body)
        {
            document.activeElement.blur();
        }

        // focus a target (sel string; placed after the blur above, which would undo
        // it otherwise); preventScroll leaves the scrolling to scrollto
        if (typeof ret.focus === 'string' && ret.focus != '')
        {
            _pri.dbg('    focus ...', ret.focus);
            let $fcs = $(ret.focus);
            if ($fcs.length > 0)
            {
                $fcs.get(0).focus({preventScroll: true});
            }
        }
    };

    _pri.emsgClick = function(e)
    {
        e.stopImmediatePropagation();
        e.stopPropagation();
        e.preventDefault();

        _pri.dbgG('*** emsgClick()');

        var $this = $(this);
        var v = $this.attr('href');

        _pri.dbgG('    href:', v);

        if (_pri.clsacc != null && v.substr(0, 3) == 'cl_')
        {
            _pri.clsacc.scrollTo(v);
        }
        else
        {
            let $elm = [];

            if (v.substring(0, 1) == '#')
            {
                $elm = $(v);
            }

            if ($elm.length == 0)
            {
                $elm = $('input[name="' + v + '"]');
            }

            if ($elm.length == 0)
            {
                $elm = $('textarea[name="' + v + '"]');
                if ($elm.length > 0)
                {
                    if ($elm.hasClass('tmc'))
                    {
                        $elm = $elm.siblings('.mce-tinymce');
                    }
                    // return true;
                }
            }

            if ($elm.length == 0)
            {
                $elm = $('select[name="' + v + '"]');
                if ($elm.length > 0)
                {
                    $elm = $elm.siblings('.vinp');
                }
            }

            if ($elm.length > 0)
            {
                _pri.page.scrollToElm($elm);
            }

            return false;
        }
    };

    publ.get = function(win, data, cbf)
    {
        _pri.dbg('*** publ.get() win:', win, 'cbf?:', (typeof cbf === 'function'));
        _pri.dbg('    data:', data);
        // _pri.dbg('    cbf:', cbf);

        // if (typeof cbf !== 'function' && $.inArray(win, _pri.wins) === -1)
        // {
        //     return;
        // }

        _pri.is_loading = true;
        _pri.showMask();

        _pri.page.trigger('modal:get', {url: win});

        var opts = {
            url: win + '?tkn=' + JW.Page.getUId(32),
            dataType: 'html'
        };

        if (typeof data === 'undefined')
        {
            opts['type'] = 'GET';
        }
        else
        {
            opts['type'] = 'POST';
            opts['data'] = data;
            // allow overwrite of dataType attribute by provided data object
            if (data.hasOwnProperty('dataType'))
            {
                opts.dataType = data.dataType;
            }
        }

        $.ajax(opts).done(function(ret, stat_str, jq_xhr) {
            _pri.dbgG('*** get() done win:', win);
            _pri.page.trigger('modal:get_done', {url: win});

            //_pri.dbg('stat_str:', stat_str);
            _pri.dbg('    jqXHR:', jq_xhr);

            _pri.is_loading = false;

            if (!_pri.handleStatus(jq_xhr))
            {
                if (typeof cbf === 'function')
                {
                    _pri.closeMaskAnim();
                    cbf(ret, stat_str, jq_xhr);
                }
                else
                {
                    _pri.dbg('    ... no cbf ...');

                    var $ret = $(ret);
                    var $imgs = $ret.find('.img-fluid');
                    var len = $imgs.length;
                    //_pri.dbg('$imgs', $imgs);

                    var $vids = $ret.find('video');
                    var vlen  = $vids.length;

                    if (len > 0)
                    {
                        var img_loaded = 0;
                        $.each($imgs, function(k, v) {
                            //_pri.dbg('img k:' + k, v);
                            $img = $(v);
                            //_pri.dbg($img.prop('complete'));
                            if ($img.prop('complete'))
                            {
                                ++img_loaded;
                                if (img_loaded == len)
                                {
                                    _pri.dbg('    ok - show win [1]');
                                    _pri.showWin($ret, win);
                                }
                            }
                            else
                            {
                                $img.on('load', function() {
                                    ++img_loaded;
                                    if (img_loaded == len)
                                    {
                                        _pri.dbg('    ok - show win [2]');
                                        _pri.showWin($ret, win);
                                    }
                                });
                            }
                        });
                    }
                    else if (vlen > 0)
                    {
                        var vcnt = 0;
                        $vids.on('loadedmetadata', function() {

                            _pri.dbg('    got metadata ...');
                            // this.play();
                            if (++vcnt >= vlen)
                            {
                                _pri.dbg('    ok - show win [4]');
                                _pri.showWin($ret, win, {vids: $vids});
                            }
                        });
                    }
                    else
                    {
                        _pri.dbg('    ok - show win [3]');
                        if (typeof data === 'object' && data != null && typeof data.cmw !== 'undefined')
                        {
                            if (data.cmw == 1)
                            {
                                _pri.dbgY('        close all mdl wins ...');
                                _pri.closeWinForce();
                            }
                        }
                        _pri.showWin($ret, win);
                    }
                }
            }
            else
            {
                _pri.closeMaskAnim();
            }
        }).fail(function(jq_xhr, stat_str) {
            _pri.dbg('!!! get failed! win: ', win);
            //XXX do not comment in production ...
            window.location.href = _pri.opts.home_url;
        });
    };

    _pri.posWin = function($mwin)
    {
        if ($mwin.length < 1)
        {
            _pri.dbgR('!!! posWin() mwin not valid!');
            return;
        }

        var wh = _pri.$win.height();
        var ww = _pri.$win.width();
        _pri.dbg('ww', ww, 'wh', wh);

        var w = $mwin.outerWidth();
        var h = $mwin.outerHeight();

        let fmwp = $mwin.data('fmwp'); // force mwp
        // _pri.dbgY('force mwp:', fmwp);

        if (typeof fmwp === 'number')
        {
            fmwp = Math.min(ww, fmwp);
            // _pri.dbgY('fwmp 2:', fmwp);
            let sfac = fmwp / w;
            w = sfac * w;
            // h = sfac * h;
            $mwin.outerWidth(w);
            h = $mwin.outerHeight();
        }

        let fcont = $mwin.data('fcont'); // full content
        if (typeof fcont === 'boolean' && fcont)
        {
            w = Math.min(1200, ww - 10);
            h = wh - 10;
            $mwin.outerWidth(w);
            $mwin.outerHeight(h);
        }

        let fscrn = $mwin.data('fscrn'); // full screen
        if (typeof fscrn === 'boolean' && fscrn)
        {
            w = ww - 10;
            h = wh - 10;
            $mwin.outerWidth(w);
            $mwin.outerHeight(h);
        }

        _pri.dbg('mdl ow', w, 'mdl oh', h);

        var x = Math.round((ww - w) / 2);
        var y = Math.round((wh - h) / 2);

        //_pri.dbg('x', x, 'y', y);

        y -= Math.ceil(y / 20);

        x = Math.max(0, x);
        y = Math.max(0, y);
        //_pri.dbg('x', x, 'y', y);
        $mwin.css('left', x + 'px');
        $mwin.css('top', y + 'px');
        $mwin.find('.mdl-hdl-ttl-txt').css('max-width', (w - 160) + 'px');
        $mwin.find('.mdl-spc').remove();
    };

    publ.posMdl = function(sel)
    {
        let $mwin = (typeof sel === 'undefined') ? _pri.$mwin : $(sel);
        if ($mwin && $mwin.length > 0)
        {
            _pri.posWin($mwin);
        }
    };

    _pri.showWin = function($win, win, opts)
    {
        _pri.dbgG('*** showWin() win:', win);

        _pri.curwin = win;
        _pri.$mwin = $win;

        _pri.$mwin.on('resize', function () {
            _pri.dbgR('*** mwin resize ...');
        });

        _pri.$mwin.one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {
            // _pri.$mwin.addClass('scrl');
            if (typeof opts === 'object' && typeof opts.vids === 'object')
            {
                $.each(opts.vids, function(k, v) {
                    // _pri.dbg('    --- v', v);
                    if ($(v).attr('autoplay'))
                    {
                        // _pri.dbg('    attr autoplay:', $(v).attr('autoplay'));
                        if (v.paused)
                        {
                            v.play();
                        }
                    }
                });
            }
        });
        _pri.$mwin.addClass('animated ' + _pri.opts.a_in);

        _pri.$body.prepend(_pri.$mwin);

        _pri.posWin(_pri.$mwin);

        _pri.$mwin.show();

        // setTimeout(function() {
        //     var wn = _pri.$mwin.outerWidth();
        //     var hn = _pri.$mwin.outerHeight();
        //
        //     _pri.dbg('mdl ow', wn, 'mdl oh', hn);
        // }, 100);

        switch (win)
        {
            case 'msg':
                _pri.dbg('        init for win msg');
                var $btn_ok = _pri.$mwin.find('a.mdl-msg-ok');
                if ($btn_ok.length > 0)
                {
                    $btn_ok.focus();
                }
            break;

            case '/login':
                // _pri.dbg('    window.location.href: ', window.location.href);
                $('#url_cur').val(window.location.href);
            break;

            default:

            break;
        }

        let mdlonl = _pri.$mwin.data('mdlonl');
        if (typeof mdlonl === 'object')
        {
            publ.handleJSONRet(mdlonl);
        }
    };

    _pri.showMask = function()
    {
        _pri.dbg('*** _pri.showMask() _pri.masked: ', _pri.masked);
        if (!_pri.masked)
        {
            _pri.masked = true;
            _pri.disableScroll('mdl-open');
            _pri.$body.append(_pri.$mask);
            _pri.$mask.show(0);
            _pri.$mask.css('opacity', 1);
            //_pri.$mwin.show();

            $('body').children('div, header, main, footer').not('.mdl, .mdl-mask').attr('aria-hidden', 'true');
        }
        else if (_pri.is_mask_hiding)
        {
            _pri.$mask.css('opacity', 1);
            _pri.show_mask_again = true;
        }
    };

    _pri.maskClicked = function()
    {
        _pri.dbg('*** maskClicked()');

        if (!_pri.is_loading && !_pri.mask_forced)
        {
            _pri.closeAll();
        }
    }

    _pri.closeAll = function(e)
    {
        // _pri.dbg('*** closeAll() this:', this);
        _pri.dbg('    curwin: ', _pri.curwin);
        //_pri.dbg(typeof e);

        if (_pri.curwin != '')
        {
            // setc0: before close
            // setc1: after close ... not used for now ... replace load_url later ...
            var setc0 = $('.mdl').data('setc0');
            if (typeof setc0 !== 'undefined')
            {
                publ.onJsSet(setc0);
            }
        }
        else if (typeof e === 'object') // new - watch out for regressions! we need a window stack ...!
        {
            var $this = $(this);
            _pri.dbg('    $this:', $this);
            var $mwin = $this.closest('.mdl');
            if ($mwin.length == 1)
            {
                _pri.curwin = 'win_tmp_id_' + _pri.page.getUId();
                _pri.$mwin  = $mwin;
            }
        }

        var load_url = false;

        if (typeof e === 'object')
        {
            e.preventDefault();

            var rld = $(this).closest('.mdl').data('rld');
            if (typeof rld !== 'undefined')
            {
                _pri.dbg('    rld found ...');

                if (rld === true)
                {
                    load_url = true;
                }
                else if (rld != '')
                {
                    load_url = rld;
                }
            }
        }

        // var win = _pri.curwin;

        _pri.closeWinAnim(function() {
            // _pri.closeMask();
            _pri.closeMaskAnim();
            /*
            if (win == '/cple')
            {
                window.location.reload(true);
            }
            */
            if (load_url === true)
            {
                _pri.dbg('    location.reload ...');
                window.location.reload(true);
            }
            else if (typeof load_url === 'string')
            {
                window.location.replace(load_url);
            }
        });
    };

    _pri.closeWin = function()
    {
        if (_pri.curwin != '')
        {
            _pri.page.trigger('modal:close_win', {win: _pri.curwin});
            _pri.curwin = '';
            _pri.$mwin.remove();
            // cleanup body-attached TATextInput dropdowns that belonged to the modal
            $('body > .jb-dd-wrp.tai-mvd').remove();
        }
    };

    _pri.closeWinForce = function()
    {
        _pri.dbgG('*** closeWinForce()');
        _pri.closeWin();
        $('body > .mdl').remove();
    };

    _pri.closeWinAnim = function(cb)
    {
        if (_pri.curwin != '')
        {
            // no animate class here - for now
            if ($('body').hasClass('stage-edt'))
            {
                _pri.closeWin();
                if (typeof cb === 'function')
                {
                    // _pri.closeWin(); //??? call twice? - commented 200421
                    cb();
                }
            }
            else
            {
                _pri.$mwin.one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(e) {
                    // _pri.dbg('    on anim END e: ', e);
                    if (typeof cb === 'function')
                    {
                        _pri.closeWin();
                        cb();
                    }
                });
                _pri.$mwin.removeClass(_pri.opts.a_in);
                _pri.$mwin.addClass(_pri.opts.a_out);
            }
        }
        else
        {
            if (typeof cb === 'function')
            {
                cb();
            }
        }
    };

    _pri.hideWin = function(cb)
    {
        if (_pri.curwin != '')
        {
            _pri.$mwin.one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(e) {
                _pri.$mwin.hide();
                if (typeof cb === 'function')
                {
                    cb();
                }
                // _pri.dbg('    on anim END e: ', e);
            });
            _pri.$mwin.removeClass(_pri.opts.a_in);
            _pri.$mwin.addClass(_pri.opts.a_out);
        }
    }

    _pri.closeMask = function()
    {
        _pri.dbgY('*** closeMask() mask_forced:', _pri.mask_forced);
        if (!_pri.mask_forced)
        {
            _pri.$mask.css('opacity', '');
            _pri.$mask.css('display', '');
            _pri.$mask.remove();
            _pri.enableScroll('mdl-open');
            _pri.masked = false;

            $('body').children('div, header, main, footer').not('.mdl, .mdl-mask').removeAttr('aria-hidden');
        }
    };

    _pri.closeMaskAnim = function(cb)
    {
        _pri.dbgY('*** closeMaskAnim() mask_forced:', _pri.mask_forced);
        if (_pri.masked)
        {
            _pri.dbg('    is masked ...');
            if (!_pri.mask_forced)
            {
                _pri.dbg('    not forced ...');
                _pri.is_mask_hiding = true;
                _pri.$mask.css('opacity', 0);
                setTimeout(function() {
                    if (_pri.show_mask_again)
                    {
                        _pri.show_mask_again = false;
                    }
                    else
                    {
                        _pri.closeMask();
                    }
                    _pri.is_mask_hiding = false;
                    if (typeof cb === 'function')
                    {
                        cb();
                    }
                }, 500);
            }
        }
        else
        {
            if (typeof cb === 'function')
            {
                cb();
            }
        }
    };

    // bcls - body class
    _pri.disableScroll = function(bcls)
    {
        _pri.dbgG('*** disableScroll() bcls:', bcls);

        //window.oldScrollPos = $(window).scrollTop();
        //$(window).on('DOMMouseScroll scroll touchmove mousewheel', _pri.scrollDisabler);

        _pri.$body.addClass(bcls);

        // if ((bcls == 'mdl-open' && !_pri.$body.hasClass('mbd-open')) || (bcls == 'mbd-open' && !_pri.$body.hasClass('mdl-open')))
        // {
        //     var sz = JW.Page.getScrollBarSize();
        //     var szmx = _pri.$win.width() - 1030;
        //
        //     if (szmx > 0)
        //     {
        //         szmx = Math.min(szmx, sz[0]);
        //
        //         _pri.dbg('doc h: ', JW.Page.getDocHeight());
        //         _pri.dbg('win h: ', $(window).height());
        //         if (JW.Page.getDocHeight() > $(window).height())
        //         {
        //             _pri.$body.css('padding-right', sz[0] + 'px');
        //             _pri.$nav_top_main.css('padding-right', (15 - szmx) + 'px');
        //
        //             _pri.$nav_top.css('width', 'calc(100% + ' + szmx + 'px)');
        //             _pri.$nav_top.css('margin-left', '-' + szmx + 'px');
        //
        //             // _pri.$nav_top.css('padding-right', sz[0] + 'px');
        //             // _pri.$nav_top_sub.css('margin-right', '-' + sz[0] + 'px');
        //             // _pri.$nav_top_sub.css('margin-left', '-' + sz[0] + 'px');
        //             // // _pri.$nav_top_sub.css('padding-right', sz[0] + 'px');
        //         }
        //     }
        // }
    };

    // _pri.scrollDisabler = function(e)
    // {
    //     //$(window).scrollTop( window.oldScrollPos );
    //     //_pri.dbg('e: ', e);
    //     if (_pri.curwin == '' || _pri.$mwin.has(e.target).length === 0)
    //     {
    //         //_pri.dbg('    ... prevented');
    //         e.preventDefault();
    //         e.stopImmediatePropagation();
    //         return false;
    //     }
    // };

    _pri.enableScroll = function(bcls)
    {
        _pri.dbgG('*** enableScroll() bcls:', bcls);

        // $(window).off('DOMMouseScroll scroll touchmove mousewheel', _pri.scrollDisabler);
        // _pri.dbg('    bcls:', bcls, 'body.hasClass(bcls)?:', _pri.$body.hasClass(bcls));
        _pri.$body.removeClass(bcls);

        // if ((bcls == 'mdl-open' && !_pri.$body.hasClass('mbd-open')) || (bcls == 'mbd-open' && !_pri.$body.hasClass('mdl-open')))
        // {
        //     _pri.$body.css('padding-right', '');
        //     _pri.$nav_top_main.css('padding-right', '');
        //
        //     _pri.$nav_top.css('width', '');
        //     _pri.$nav_top.css('margin-left', '');
        //
        //     // _pri.$nav_top.css('padding-right', '');
        //     // _pri.$nav_top_sub.css('margin-right', '');
        //     // _pri.$nav_top_sub.css('margin-left', '');
        //     // // _pri.$nav_top_sub.css('padding-right', '');
        // }
    };

    _pri.mbtnClick = function(e)
    {
        if (typeof e === 'object' && typeof e === 'function')
        {
            e.preventDefault();
        }

        _pri.dbg('*** mbtn.click()');

        if (_pri.$nav_top_sub.hasClass('show'))
        {
            _pri.setTopNavSub(false);
        }
        else
        {
            _pri.setTopNavSub(true, _pri.$nav_top_sub);
        }

        return false;
    };

    _pri.mbdClick = function(e)
    {
        if (typeof e === 'object' && typeof e === 'function')
        {
            e.preventDefault();
        }

        _pri.dbg('*** bd.click()');

        _pri.setTopNavSub(false);
    };

    // set top nav sub and menu backdrop mask
    _pri.setTopNavSub = function(show, $el)
    {
        if (show)
        {
            if (_pri.$nav_top_open != null)
            {
                _pri.$nav_top_open.collapse('hide');
            }

            _pri.$nav_top_open = $el;

            // $('#divTool').hide();
            _pri.disableScroll('mbd-open');
            _pri.$body.append(_pri.$bd);
            _pri.$nav_top_open.collapse('show');
            _pri.$nav_top.css('overflow-y', 'auto');
            _pri.$nav_top.css('max-height', '100%');
            _pri.$nav_top.css('overflow-x', 'hidden');

            _pri.page.trigger('modal:top_nav_shown');

            // if ($divTool.length)
            //
            // var divTool = document.getElementById("divTool");
            // if (divTool != null)
            // {
            //     _pri.dbg('   *** divTool found');
            //     var r = parseInt(divTool.style.paddingRight, 10);
            //     _pri.dbg('   *** r scrlbsz: ', r, JW.Page.getScrollBarSize());
            //
            //     divTool.style.right = (r + JW.Page.getScrollBarSize()[0]) + "px";
            // }
        }
        else
        {
            if (_pri.$nav_top_open != null)
            {
                _pri.$bd.remove();
                _pri.$nav_top_open.collapse('hide');
                _pri.$nav_top.css('overflow-y', '');
                _pri.$nav_top.css('max-height', '');
                _pri.$nav_top.css('overflow-x', '');
                _pri.enableScroll('mbd-open');
                // $('#divTool').show();
                _pri.$nav_top_open = null;

                _pri.page.trigger('modal:top_nav_hidden');
            }
        }
    }

    _pri.getPart = function(part, data)
    {
        _pri.dbgG('*** getPart()');

        var opts = {
            type: 'GET',
            url: _pri.opts.urls.tpl + '/' + part + '?tkn=' + JW.Page.getUId(32),
            dataType: 'html'
        };

        if (typeof data === 'object' && data != null)
        {
            _pri.dbg('    data object provided data:', data);

            opts.type = 'POST';
            opts.data = data;
        }

        $.ajax(opts).done(function(ret, stat_str, jq_xhr) {
            _pri.dbg('*** getPart(' + part + ') done');
            // _pri.page.trigger('modal:get_part_done', {part: part});

            //_pri.dbg('status:', stat_str);
            //_pri.dbg('jqXHR:', jq_xhr);

            if (!_pri.handleStatus(jq_xhr))
            {
                _pri.page.setPart(part, ret);
            }

        });
    };

    _pri.showLoading = function()
    {
        if ($('body').has('#load-indicator').length == 0)
        {
            $('body').append(_pri.$load_ind);
        }
    };

    _pri.hideLoading = function()
    {
        _pri.$load_ind.remove();
    };

    _pri.srf = function()
    {
        $.ajax(_pri.opts.srf_ajx).done(_pri.srfDone);
        return false;
    };

    _pri.srfDone = function(ret, stat_str, jq_xhr)
    {
        // _pri.dbg('*** srfDone()');
        //_pri.dbg('         ret: ', ret, ' | stat_str: ', stat_str, ' | jq_xhr: ', jq_xhr);
        JW.Page.setLoggedIn((typeof ret == 'object' && ret.hasOwnProperty('ili') && ret.ili == '1'));
        setTimeout(_pri.srf, _pri.srf_tio);
    };

    _pri.initOpts = function()
    {
        _pri.opts.srf_ajx = {
            type: "GET",
            url: _pri.opts.urls.srf,
            data: {},
            dataType: 'json'
        };
        _pri.opts.rating_cur = {
            theme: '',
            emptyStar: '<i class="glyphicon glyphicon-star"></i>',
            language: 'de',
            displayOnly: true,
            size: 'xs'
        };
        _pri.opts.rating_cur_sm = {
            theme: '',
            emptyStar: '<i class="glyphicon glyphicon-star"></i>',
            language: 'de',
            displayOnly: true,
            size: 'sm'
        };
        _pri.opts.rating_edit = {
            theme: '',
            emptyStar: '<i class="glyphicon glyphicon-star"></i>',
            language: 'de',
            showClear: false,
            size: 'lg',
            starCaptionClasses: {
                0.5: 'label label-info',
                1: 'label label-info',
                1.5: 'label label-info',
                2: 'label label-info',
                2.5: 'label label-info',
                3: 'label label-info',
                3.5: 'label label-info',
                4: 'label label-info',
                4.5: 'label label-info',
                5: 'label label-info'
            }
        };
    };


    _pri.initLinks = function()
    {
        $(document).on('click', '.cll', function(e) {
            var $this = $(this);
            var cll = $this.data('cll');
            _pri.dbg(typeof cll, cll);
            if (typeof cll === 'string')
            {
                cll = JSON.parse(cll);
            }

            if (typeof cll === 'object')
            {
                // event propagation
                if (typeof e === 'object' && typeof cll._evp !== 'undefined' && cll._evp == false)
                {
                    e.preventDefault();
                }
                cll._$elm = $this;
                publ.cll(cll);
            }
            else
            {
                // simply call /_wgt/aba/obo/ubu and handle returned json ...
                e.preventDefault();

                let href = $this.prop('href');

                if (typeof href === 'undefined' || !href)
                {
                    href = $this.data('href');
                    if (typeof href === 'undefined' || !href)
                    {
                        return false;
                    }
                }

                let cll =
                {
                    _dtp: 'JSON',
                    _url: href,
                    _mth: 'POST'
                };

                publ.cll(cll);
            }
        });

        // on change: with changed array ... or simple cll
        $(document).on('change', '.cllcha', function(e) {

            _pri.dbgG('*** cllcha on change()');

            var $this = $(this);
            var cllo = $this.data('cll');
            _pri.dbg(typeof cllo, cllo);
            if (typeof cllo === 'object' && typeof cllo._cha === 'object')
            {
                var cll = $.extend({}, cllo);
                // event propagation
                if (typeof e === 'object' && typeof cll._evp !== 'undefined' && cll._evp == false)
                {
                    e.preventDefault();
                }

                cll._$elm = $this;
                var cha = cll._cha;
                delete cll._cha;

                _pri.dbg('    this.type:', this.type);
                if (this.type && this.value && (this.type === 'checkbox' || this.type === 'radio') && typeof cha[this.value] === 'object' && typeof cha['0'] === 'object')
                {
                    _pri.dbg('    checked?', this.checked);
                    if (this.checked)
                    {
                        $.extend(true, cll, cha[this.value]);
                    }
                    else
                    {
                        $.extend(true, cll, cha['0']);
                    }
                    _pri.dbg('    cll:', cll);
                    publ.cll(cll);
                }
                else if (typeof cll._opts === 'boolean' && cll._opts)
                {
                    _pri.dbg('    opts_mode ...');
                    _pri.dbg('    this.value', this.value);
                    if (typeof cha[this.value] === 'object' || typeof cha['0'] === 'object')
                    {
                        if (typeof cha[this.value] === 'object')
                        {
                            $.extend(true, cll, cha[this.value]);
                        }
                        else if (typeof cha['0'] === 'object')
                        {
                            $.extend(true, cll, cha['0']);
                        }
                        _pri.dbg('    cll:', cll);
                        publ.cll(cll);
                    }
                }
                else if (this.type === 'select-one')
                {
                    _pri.dbg('    select-one');
                    _pri.dbg('    ????????????????????????????????????????????????');
                    _pri.dbg('    this.value', this.value);

                    // let $opt = $this.find('option:selected');
                    // let val;
                    // if ($opt.length > 0)
                    // {
                    //     val =
                    // }

                    $.extend(true, cll, cha[this.value]);
                    _pri.dbg('cll:', cll);
                    publ.cll(cll);
                }
                //
                //
                //
                // publ.cll(cll);
            }
            // else
            // {
            //     _pri.dbgR('    no _cha - not handled for now ...');
            // }
        });

        $(document).on('click', '.ajx', function(e) {

            e.preventDefault();
            _pri.dbgG('*** onClick .ajx ()');

            var $this = $(this);
            var win = this.getAttribute('href');

            if (typeof win === 'undefined' || !win)
            {
                win = $this.data('href');
                if (typeof win === 'undefined' || !win)
                {
                    return false;
                }
            }

            var win_href = win;
            _pri.dbg('    win_href:', win_href);

            switch(win)
            {
                case '/rate':
                    var cpid = $this.data('cpid');
                    _pri.closeWinAnim(function() {
                        publ.get(win, {cpid: cpid});
                    });
                break;
                case '/ratings':
                    var cpid = $this.data('cpid');
                    _pri.closeWinAnim(function() {
                        publ.get(win, {cpid: cpid});
                    });
                break;
                case '/berufsfilm':
                    var jpid = $this.data('jpid');
                    _pri.closeWinAnim(function() {
                        publ.get(win, {jpid: jpid});
                    });
                break;
                // branch price
                case '/bpr':
                    var pid = $this.data('pid');
                    _pri.closeWinAnim(function() {
                        publ.get(win, {pid: pid});
                    });
                break;
                // premiums, cpl edit
                case '/cple':
                    var pid = $this.data('pid');
                    var act = $this.data('act');
                    _pri.closeWinAnim(function() {
                        publ.get(win, {pid: pid, act: act});
                    });
                break;
                case '/_ajx':
                    _pri.commonAjxCall($this);
                break;
                default:

                    var win_arr = win.split('/');
                    _pri.dbg('    win_arr:', win_arr);

                    if (win_arr.length > 2)
                    {
                        win = '/' + win_arr[1];
                        switch (win)
                        {
                            case '/ratings':
                                var cpid = win_arr[2];
                                var pg = 1;
                                if (win_arr.length >= 3)
                                {
                                    pg = win_arr[3];
                                }
                                _pri.closeWinAnim(function() {
                                    publ.get(win, {cpid: cpid, pg: pg});
                                });
                            break;

                            case '/info':
                                _pri.closeWinAnim(function() {
                                    publ.get(win_href);
                                });
                            break;

                            // /login/fair
                            case '/login':
                                var fid = $this.data('fid');
                                var flnk = $this.data('flnk');
                                _pri.closeWinAnim(function() {
                                    publ.get(win, {fid: fid, flnk: flnk});
                                });
                            break;

                            default:
                                _pri.closeWinAnim(function() {
                                    // publ.get(win); // changed 180622 - watch out ...
                                    publ.get(win_href);
                                });
                            break;
                        }
                    }
                    else
                    {
                        _pri.closeWinAnim(function() {
                            publ.get(win);
                        });
                    }
                break;
            }
            return false;
        });

        $(document).on('change', '.ajxc', function(e) {
            e.preventDefault();
            var $this = $(this);
            var $elm;
            if ($this.prop('tagName') == 'SELECT')
            {
                $elm = $this.find('option:selected');
            }
            else
            {
                $elm = $this;
            }
            _pri.commonAjxCall($elm);
        });
    };

    _pri.commonAjxCall = function($elm)
    {
        _pri.dbg('*** commonAjxCall()');
        // camel-case conversion! use data-data-type for data.dataType ... grrrrrrrrrrrrrr
        var data = $elm.data();
        // _pri.dbg('    $elm.data:', data);

        var dele       = ['toggle', 'bs.tooltip'];
        var dele_found = [];
        for (var i = 0; i < dele.length; ++i)
        {
            if (typeof data[dele[i]] !== 'undefined')
            {
                _pri.dbgY('    delete ' + dele[i] + ' ...');
                delete data[dele[i]];
                dele_found.push(dele[i]);
            }
        }

        if ($.inArray('bs.tooltip', dele_found) !== -1)
        {
            _pri.dbgY('    brutally remove all tooltips ...');
            $('.tooltip.show').remove();
        }

        var href = $elm.data('href');
        if (typeof href === 'undefined' || !href)
        {
            return false;
        }

        if (typeof data.curvals === 'object')
        {
            _pri.dbg('curvals:', data.curvals);
            var curelm;
            $.each(data.curvals, function(k, v) {
                _pri.dbg('    k:', k, ' v:', v, ' val:', $(k).val());
                if (v)
                {
                    curelm = $(k);
                    if (curelm.length == 1)
                    {
                        data[k.substring(1)] = curelm.val();
                    }
                }
            });
        }

        var cbf = null;
        // custom callback: 1 - handleJSONRet()
        if (typeof data.ccbf !== 'undefined' && data.ccbf == 1)
        {
            cbf = publ.handleJSONRet;
        }

        _pri.closeWinAnim(function() {
            publ.get(href, data, cbf);
        });
    };

    _pri.onJsSetE = function(e)
    {
        _pri.dbg('*** onJsSetE() ', e.target.nodeName);
        e.stopImmediatePropagation();
        e.stopPropagation();
        e.preventDefault();
        var set, $opt;
        if (e.target.nodeName == 'SELECT')
        {
            $opt = $(this).find('option:selected');
            set = $opt.data('set');
        }
        else
        {
            set = $(this).data('set');
        }
        publ.onJsSet(set);

        // a select option may additionally trigger an ajax reload of dependent areas
        // (data-href) - runs through the existing commonAjxCall / handleJSONRet path.
        // Skip the change the jb-select widget fires on init: only react to an actual
        // value change (compare against the last value reacted to).
        if (typeof $opt !== 'undefined' && typeof $opt.data('href') !== 'undefined' && $opt.data('href'))
        {
            var $sel = $(this);
            var val  = $sel.val();
            if (typeof $sel.data('ajx_cur') === 'undefined')
            {
                $sel.data('ajx_cur', val);
            }
            else if (val !== $sel.data('ajx_cur'))
            {
                $sel.data('ajx_cur', val);
                _pri.commonAjxCall($opt);
            }
        }

        return false;
    };

    //TODO use handleJSONRet or sthg more generic ...
    publ.onJsSet = function(set)
    {
        _pri.dbg('*** onJsSet()');
        _pri.dbg('    set:', set);
        if (typeof set === 'object')
        {
            var cur, $src, $dst, p;

            // field to value
            if (typeof set['_f2v'] === 'object')
            {
                cur = set['_f2v'];
                for (p in cur)
                {
                    $dst = $(p);
                    if ($dst.length > 0)
                    {
                        if ($dst.is(':checkbox') && (cur[p] === true || cur[p] === false))
                        {
                            _pri.dbg('    found checkbox, evaluate val: [' + cur[p] + ']');
                            if (cur[p] === false)
                            {
                                $dst.prop('checked', false);
                            }
                            else
                            {
                                $dst.prop('checked', true);
                                // $elm.trigger('change');
                            }
                        }
                        else
                        {
                            $dst.val(cur[p]);
                        }
                    }
                    else
                    {
                        _pri.dbg('    !!! _f2v dst: [' + p + '] not found!');
                    }
                }
            }

            // field to checkbox
            if (typeof set['_f2c'] === 'object')
            {
                cur = set['_f2c'];
                for (p in cur)
                {
                    $dst = $(p);
                    if ($dst.length > 0)
                    {
                        $src = $(cur[p]);
                        if ($src.length > 0)
                        {
                            if ($src.is(':checked'))
                            {
                                $dst.val($src.val());
                            }
                            else
                            {
                                $dst.val('');
                            }
                        }
                        else
                        {
                            _pri.dbg('    !!! _f2c src: [' + cur[p] + '] not found!');
                        }
                    }
                    else
                    {
                        _pri.dbg('    !!! _f2c dst: [' + p + '] not found!');
                    }
                }
            }

            if (typeof set.crem !== 'undefined' && $.isPlainObject(set.crem))
            {
                _pri.dbg('    crem ...');
                $.each(set.crem, function(k, v) {
                    _pri.dbg('        ' + k);
                    _pri.dbg('        ', $(k));
                    $(k).removeClass(v);
                });
            }

            if (typeof set.cadd !== 'undefined' && $.isPlainObject(set.cadd))
            {
                _pri.dbg('    cadd ...');
                $.each(set.cadd, function(k, v) {
                    _pri.dbg('        ' + k);
                    $(k).addClass(v);
                });
            }

            if (typeof set._inps !== 'undefined' && $.isPlainObject(set._inps))
            {
                _pri.dbg('    _inps ...');
                $.each(set._inps, function(k, v) {
                    _pri.dbg('        ' + k, v);
                    if (v == 'disable')
                    {
                        // var $inps = $(k).find('input');
                        // _pri.dbg('    $inps:', $inps);

                        $(k).find('input').prop('disabled', true);
                        $(k).find('select').prop('disabled', true);
                    }
                    else if (v == 'enable')
                    {
                        // var $inps = $(k).find('input');
                        // _pri.dbg('    $inps:', $inps);

                        $(k).find('input').prop('disabled', false);
                        $(k).find('select').prop('disabled', false);
                    }
                });
            }

            // on toggle ...
            if (typeof set['_otg'] === 'object')
            {
                _pri.dbg('    _otg ...');
                cur = set['_otg'];
                if ($.isPlainObject(cur))
                {
                    for (p in cur)
                    {
                        $dst = $(p);
                        if ($dst.length > 0 && $dst.is(':checkbox'))
                        {
                            _pri.dbg('        "' + p + '" cur checked: ' + $dst.prop('checked') + ' ... ' + $dst.is(':checked'));

                            let _$dst = $dst;
                            let _curp = cur[p];
                            window.setTimeout(function() {
                                _$dst.prop('checked', !_$dst.prop('checked'));
                                _$dst.trigger('change');
                                _pri.dbg('            checked: ' + _$dst.prop('checked') + ' ... ' + _$dst.is(':checked'));

                                if (_$dst.prop('checked') && typeof _curp['onc'] === 'object')
                                {
                                    publ.onJsSet(_curp['onc']);
                                }
                                else if (!_$dst.prop('checked') && typeof _curp['onu'] === 'object')
                                {
                                    publ.onJsSet(_curp['onu']);
                                }
                            }, 100);


                        }
                        else
                        {
                            _pri.dbg('    !!! _tgl: [' + p + '] not found!');
                        }
                    }
                }
            }

            // form to submit
            if (typeof set['_frm'] === 'object')
            {
                cur = set['_frm'];
                for (p in cur)
                {
                    $dst = $(p);
                    if ($dst.length > 0)
                    {
                        if (cur[p] == 'sub')
                        {
                            _pri.is_loading = true;
                            _pri.hideWin(function() {
                                $dst.submit();
                            });
                        }
                        else
                        {
                            _pri.dbg('    !!! _frm act: [' + cur[p] + '] unknown!');
                        }
                    }
                    else
                    {
                        _pri.dbg('    !!! _frm dst: [' + p + '] not found!');
                    }
                }
            }

            // trigger events on elements
            if (typeof set['_tri'] === 'object')
            {
                cur = set['_tri'];
                for (p in cur)
                {
                    $dst = $(p);
                    if ($dst.length > 0)
                    {
                        if (cur[p] == 'cli')
                        {
                            $dst.trigger('click');
                        }
                        else if (cur[p] == 'change')
                        {
                            $dst.trigger(cur[p]);
                        }
                        else
                        {
                            _pri.dbg('    !!! _tri act: [' + cur[p] + '] unknown!');
                        }
                    }
                    else
                    {
                        _pri.dbgR('    !!! _tri dst: [' + p + '] not found!');
                    }
                }
            }

            // mdl actions
            if (typeof set['_mdl'] === 'object')
            {
                cur = set['_mdl'];
                for (p in cur)
                {
                    if (p == _pri.curwin)
                    {
                        if (cur[p] == 'clo')
                        {
                            _pri.closeAll();
                        }
                        else
                        {
                            _pri.dbg('    !!! _mdl act: [' + cur[p] + '] unknown!');
                        }
                    }
                    else
                    {
                        _pri.dbg('    !!! _mdl p: [' + p + '] not current!');
                    }
                }
            }

            // window actions
            if (typeof set['_win'] === 'object')
            {
                cur = set['_win'];
                for (p in cur)
                {
                    if (p == 'rld')
                    {
                        window.location.reload(true);
                    }
                    else if (p == 'rpl')
                    {
                        window.location.replace(cur[p]);
                    }
                    else if (p == 'url')
                    {
                        window.location.href = cur[p];
                    }
                    else if(p == 'opn')
                    {
                        var win = window.open(cur[p]);
                    }
                    else
                    {
                        _pri.dbg('    !!! _win act: [' + p + '] unknown!');
                    }
                }
            }
        }
        else
        {
            _pri.dbg('    !!! set not found!');
        }
        return false;
    };

    _pri.getSetTplBySel = function(o)
    {
        _pri.dbgG('*** getSetTplBySel o:', o);
        if (typeof o !== 'object' || typeof o.tpl_id === 'undefined' || typeof o.tgt_id === 'undefined')
        {
            _pri.dbgR('    !!! missing object with tpl_id and tgt_id!');
            return;
        }

        let uid = _pri.page.getUId(16)
        let tpl = $(o.tpl_id)[0].outerHTML.replace(/\{RND\}/g, uid);
        let id  = o.tpl_id.replace(/#/g, '').replace(/tpl/g, uid);

        let $tpl = $(tpl);

        // _pri.dbg('tpl:', $tpl);

        $tpl.removeClass('d-none');
        $tpl.attr('id', id);

        if (typeof o.append !== 'undefined' && o.append === true)
        {
            $(o.tgt_id).append($tpl);
        }
        else
        {
            $(o.tgt_id).prepend($tpl);
        }

        _pri.page.initElm($tpl, ['datepicker']);

        if (typeof o.elmi !== 'undefined' && $.isArray(o.elmi) && o.elmi.length > 0)
        {
            _pri.page.initElm($tpl, o.elmi);
        }
    }

    // publ.dragEl = function(sel)
    // {
    //     _pri.dbgG('*** publ.dragEl()', sel);
    //
    //     var $el = $(sel);
    //     if ($el.length == 1)
    //     {
    //         _pri.dragEl($el);
    //     }
    // };
    //
    // _pri.dragEl = function($el)
    // {
    //     _pri.dbgG('*** _pri.dragEl()');
    //
    //     var pos1 = 0,
    //         pos2 = 0,
    //         pos3 = 0,
    //         pos4 = 0;
    //
    //     var $dbar = $el.find('.dbar');
    //     if ($dbar.length == 1)
    //     {
    //         $dbar.on('mousedown', dragMouseDown);
    //     }
    //     else
    //     {
    //         $el.on('mousedown', dragMouseDown);
    //     }
    //
    //     // if (document.getElementById(elmnt.id + "header"))
    //     // {
    //     //     // if present, the header is where you move the DIV from:
    //     //     document.getElementById(elmnt.id + "header").onmousedown = dragMouseDown;
    //     // }
    //     // else
    //     // {
    //     //     // otherwise, move the DIV from anywhere inside the DIV:
    //     //     elmnt.onmousedown = dragMouseDown;
    //     // }
    //
    //     function dragMouseDown(e) {
    //         e = e || window.event;
    //         e.preventDefault();
    //         // get the mouse cursor position at startup:
    //         pos3 = e.clientX;
    //         pos4 = e.clientY;
    //         // document.onmouseup = closeDragElement;
    //         // // call a function whenever the cursor moves:
    //         // document.onmousemove = elementDrag;
    //         _pri.$doc.on('mouseup', closeDragElement);
    //         _pri.$doc.on('mousemove', elementDrag);
    //     }
    //
    //     function elementDrag(e) {
    //         e = e || window.event;
    //         e.preventDefault();
    //         // calculate the new cursor position:
    //         pos1 = pos3 - e.clientX;
    //         pos2 = pos4 - e.clientY;
    //         pos3 = e.clientX;
    //         pos4 = e.clientY;
    //
    //         $el.css('top', ($el[0].offsetTop - pos2) + "px");
    //         $el.css('left', ($el[0].offsetLeft - pos1) + "px");
    //     }
    //
    //     function closeDragElement() {
    //         // // stop moving when mouse button is released:
    //         _pri.$doc.off('mouseup', closeDragElement);
    //         _pri.$doc.off('mousemove', elementDrag);
    //     }
    // };
    //
    _pri.extend();

    // expose public methods
    return publ;
})(jQuery);